import { Buttons } from '../../../controls/buttons';
import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';

@Component({
  selector: 'app-send-onboarding-dialog',
  standalone: true,
  imports: [Buttons, ModalDialogComponent],
  templateUrl: './send-onboarding-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './send-onboarding-dialog.component.scss'
})
export class SendOnboardingDialogComponent {

  isUpdate = model<boolean>(false);

  private dialog = inject(NgbActiveModal);

  send() {
    this.dialog.close(SendOnboardingDialogResult.Send);
  }

  cancel() {
    console.log('cancel');
    this.dialog.dismiss();
  }
}

export enum SendOnboardingDialogResult {
  Send,
  Cancel
}
